import styled, { css } from 'styled-components';
import { getColorVariable } from 'components/atoms/space-icon/space-icon';
import { Tabs as TabsAtom } from 'components/atoms/tabs';

const TabPaneAtom = TabsAtom.TabPane;

export const NewTabPane = styled(TabPaneAtom)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-10) var(--spacing-07);
  height: 100%;
  overflow: auto;
`;

export const Tabs = styled(TabsAtom)`
  height: calc(100vh - 63px) !important;

  .ant-tabs .ant- &.ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 0;
  }

  > .ant-tabs-nav {
    background: var(--coolest-gray-10);
    padding-left: var(--layout-01);
    padding-right: 20%;
    margin: 0;
  }

  > .ant-tabs-nav-list .ant-tabs-tab {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  && .ant-tabs-tab.ant-tabs-tab-active {
    --active-tab-border-color: var(--primary-color);
    ${({ name }: { name: string }) => css`
      --active-tab-border-color: var(${getColorVariable(name)});
    `};
    border-bottom: 2px solid var(--active-tab-border-color);
  }

  > .ant-tabs-tab .ant-tabs-tab-btn {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${NewTabPane} {
    background-color: var(--white-100);
    height: 100vh;
    overflow: auto;
  }
`;
